export const productsFiltersInitialState = {
  store: false,
  envios: false,
  // conta_digital: false,
  // TODO: include ERP filter after salesforce implementation
  tiny: false,
};

export const statutsFiltersInitialState = {
  novo: false,
  aberto: false,
  pendente: false,
  fechado: false,
};

export const statutsFiltersDictionary = {
  novo: {
    label: "Aberto",
    variation: "info",
  },
  aberto: {
    label: "Aberto",
    variation: "info",
  },
  pendente: {
    label: "Aguardando sua resposta",
    variation: "alert",
  },
  escalado: {
    label: "Aberto",
    variation: "info",
  },
  fechado: {
    label: "Finalizado",
    variation: "success",
  },
  resolvido: {
    label: "Finalizado",
    variation: "success",
  },
};

export const productDictionary = {
  store: "Loja",
  envios: "Envios",
  // conta_digital: "Conta Digital",
  tiny: "Sistema ERP",
};

export const productsFilterCheckboxes: {
  key: keyof typeof productsFiltersInitialState;
  label: string;
}[] = [
  { key: "store", label: "Loja" },
  { key: "envios", label: "Envios" },
  // { key: "conta_digital", label: "Conta Digital" },
  // TODO: include ERP filter after salesforce implementation
  { key: "tiny", label: "Sistema ERP" },
];

export const createFilterString = (
  filters: typeof productsFiltersInitialState
) => {
  return Object.entries(filters)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(",");
};
